import {
  put,
  takeEvery,
  call
} from 'redux-saga/effects';
import * as actions from '../../actions/voucherPayment.actions';
import * as actionTypes from '../../actionTypes/ActionTypes';
import VoucherPaymentServices from '../../../services/voucherPaymentServices';

export default function* getByVoucherIdSaga() {
  yield takeEvery(actionTypes.VOUCHER_PAYMENT.GET_BY_PAYMENTS_UUID_REQUEST, getByPaymentsUUID);
}

export function* getByPaymentsUUID(action) {
  try {
    const response = yield call(VoucherPaymentServices.getByPaymentsUUID, action.payload);
    const { success, data } = response;
    if (success) {
      yield put(actions.getByPaymentsUUIDSuccess(data));
    } else {
      yield put(actions.getByPaymentsUUIDdFail(response.message));
    }
  } catch (error) {
    yield put(actions.getByPaymentsUUIDdFail(error));
  }
}
